import { render, staticRenderFns } from "./RemoveKeywordConfirmModal.vue?vue&type=template&id=0ebc14ce"
import script from "./RemoveKeywordConfirmModal.vue?vue&type=script&lang=js"
export * from "./RemoveKeywordConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports